import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import Button from "../Button";

import settings from "../../config";
import Header from "../Header";
import Input from "../Input/Input";

const AssetForm = () => {
  const navigate = useNavigate();
  const { assetId } = useParams();

  const [formData, setFormData] = useState({
    assetName: "",
  });

  useEffect(() => {
    if (assetId) {
      (async () => {
        const response = await axios.post(`${settings.api}assets/view`, {
          assetId: assetId,
        });

        if (response.data.data) {
          setFormData(response.data.data[0]);
        }
      })();
    }
  }, [assetId]);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <form
      dir="rtl"
      onSubmit={async (e) => {
        e.preventDefault();

        const response = await axios.post(
          `${settings.api}assets/${assetId ? "update" : "create"}`,
          formData,
        );

        if (response.data.statusCode === 200) {
          navigate("/assets");
        }
      }}
    >
      <div className="w-full">
        <Header title="استماره الاصل" />

        <div className="flex flex-col w-full lg:w-1/2 m-auto gap-4">
          <Input
            label="اسم الاصل"
            value={formData.assetName}
            onChange={onChange}
            name="assetName"
          />

          <Button
            className="w-1/2 m-auto"
            type="submit"
            text="تسجيل"
            isDisabled={!formData.assetName}
          />
        </div>
      </div>
    </form>
  );
};

export default AssetForm;
